<template>
    <NuxtLink :to="article.path?.replace('help/', 'blog/')"
        class="block min-w-0 max-w-full rounded-lg sm:p-3 hover:bg-[var(--hover-gray)]">
        <div class="wrapper min-w-0">
            <header>
                <div class="box-title font-normal my-2 flex lg:gap-8 gap-2 items-start min-w-0">
                    <div class="flex shrink-0 items-start justify-start w-20">
                        <img :src="article.img" class="h-auto w-20 max-w-full object-contain rounded-lg py-1"
                            :alt="article.title || ''" />
                    </div>
                    <div class="min-w-0 flex-1 rounded-lg px-4 pb-2">
                        <Badge :label="tag" v-for="tag of article.tag?.split(',') || ['Product']" class="mr-2" />

                        <div class="font-semibold mt-2">{{ article.title }}</div>

                        <div class="text-xs font-normal justify-end mt-2">
                            <span class="text-medium-gray">{{ localDate(article.date) }}</span>
                            <template v-if="calcReadingTime(article)"> - {{ calcReadingTime(article) }}</template>
                        </div>

                        <p class="mt-5 line-clamp-3 box-description text-medium-gray" v-if="include_html"
                            v-html="html(article, article.body)"></p>
                    </div>
                </div>
            </header>
        </div>
    </NuxtLink>
</template>
<script lang="ts">
import { type PropType } from 'vue';
import { type IArticle, type IArticleChild, html, localDate } from '~/services/blog';

export default {
    props: {
        article: {
            type: Object as PropType<IArticle>,
            required: true,
        },
        include_html: Boolean,
    },
    methods: {
        html,
        localDate,
        calcReadingTime(article: IArticle) {
            // Computed from the post body at sync time (TICKET-10903). Cards don't load
            // the body, so without this every card fell back to the description: "1 minute".
            if (article.readingTime) {
                return `${article.readingTime} minute read`;
            }

            // No body and no stored value: show nothing rather than a wrong "1 minute read".
            if (!article.body?.children?.length) {
                return '';
            }

            let str = '';

            (article.body?.children || []).forEach((element) => {
                calc(element);
            });

            return this.readingTime(str, 'read');

            function calc(child: IArticleChild) {
                if (child.value) {
                    str += child.value;
                } else if (child.children?.length) {
                    child.children.forEach((c) => calc(c));
                }
            }
        },
        readingTime(text: string, post?: string) {
            const wordsPerMinute = 200;
            const wordCount = text.split(/\s+/).length;
            const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);

            if (readingTimeMinutes === 1) {
                return `1 minute${post ? ' ' + post : ''}`;
            }

            return `${readingTimeMinutes} minute${post ? ' ' + post : ''}`;
        },
    },
};
</script>